import { WATCH_CATS } from "../actionTypes";

export const watchcatsfunc = (data) => 
{
    return {
        type: WATCH_CATS,
        data: data,
    }
}